import React from 'react'
import TileStyled from './TileStyled'
import { DateTime } from "luxon";

function Tile({evt}) {
  return (
    <TileStyled>
      <div className="evt-image">
        <img src={evt.image} alt={evt.titre}/>
      </div>
      <div className="evt-desc">
        <div className="titre">
          {evt.titre}
        </div>
        <div className="date">
          <span className="jour">{DateTime.fromSQL(evt.date_debut).setLocale('fr').toFormat("cccc")}</span>
          <span className="num">{DateTime.fromSQL(evt.date_debut).setLocale('fr').toFormat("dd")}</span>
          <span className="horaire">{DateTime.fromSQL(evt.date_debut).setLocale('fr').toFormat("HH'h'mm")}</span>
        </div>
      </div>
    </TileStyled>
  );
}

export default Tile;
